module.exports = __webpack_public_path__ + "static/media/beef10.e4becb6a.jpeg";